/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */

/**
 * Types for Pages Titles
 *
 * @author Misha Kokoylin
 * @author Maxim Fedorov
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Julia Ignatieva
 * @author Evgeniy Naumov
 * @author Nikolay Sviridov
 * @version 1.32.0
 * @since 1.0.1
 */

export type ICommonTranslationPages = {
    [key in ECommonTranslationPages]: string;
};

export enum ECommonTranslationPages {
    account = 'account',
    accountInfo = 'accountInfo',
    autoReport = 'autoReport',
    autoReportId = 'autoReportId',
    bills = 'bills',
    callsDetail = 'callsDetail',
    campaignInfo = 'campaignInfo',
    campaigns = 'campaigns',
    cashback = 'cashback',
    dashboard = 'dashboard',
    expensesAnalyzer = 'expensesAnalyzer',
    historyOrder = 'historyOrder',
    inquiry = 'inquiry',
    inquiryInfo = 'inquiryInfo',
    labelsImport = 'labelsImport',
    moneyTransfer = 'moneyTransfer',
    news = 'news',
    pageOrderId = 'pageOrderId',
    pagePayments = 'pagePayments',
    personalAccount = 'personalAccount',
    productOfferings = 'productOfferings',
    products = 'products',
    reportsConstructor = 'reportsConstructor',
    reportsConstructorSubscribers = 'reportsConstructorSubscribers',
    settings = 'settings',
    subscriberFixed = 'subscriberFixed',
    subscriberId = 'subscriberId',
    subscriberMobile = 'subscriberMobile',
    wizardAdditionalAccounts = 'wizardAdditionalAccounts',
    wizardAdditionalReports = 'wizardAdditionalReports',
    wizardBillsDoc = 'wizardBillsDoc',
    wizardChangeLock = 'wizardChangeLock',
    wizardExpensesDetail = 'wizardExpensesDetail',
    wizardImportPersonalData = 'wizardImportPersonalData',
    wizardMultiSearch = 'wizardMultiSearch',
    wizardOrderTemplateCreate = 'wizardOrderTemplateCreate',
    wizardOrderTemplateEdit = 'wizardOrderTemplateEdit',
    wizardOrderReport = 'wizardOrderReport',
    wizardCollationReport = 'wizardCollationReport',
    wizardImportSubscribersLimits = 'wizardImportSubscribersLimits',
    wizardChangeRole = 'wizardChangeRole',
}
